import {Message} from "components/actions/response";
import { SingletonNotyf } from "./sislogNotyf";

export function show(message: Message) {
  SingletonNotyf.getInstance().show(message);
}
